import { API_V4 } from "@/services/config/auth-axios";

class Level {
  getLevels() {
    return API_V4.get("/level");
  }
}

export default new Level();
